module.exports = __webpack_public_path__ + "assets/img/key.d538086d.svg";